// actions/types.js
export const FETCH_CASE_START = 'FETCH_CASE_START';
export const FETCH_CASE_SUCCESS = 'FETCH_CASE_SUCCESS';
export const FETCH_CASE_FAILURE = 'FETCH_CASE_FAILURE';
export const ADD_CASE_FILE = "ADD_CASE_FILE";
export const REMOVE_CASE_FILE = "REMOVE_CASE_FILE";
export const MARK_CASE_SLIDE_READ = "MARK_CASE_SLIDE_READ";